import React, { Fragment, useState } from 'react';
import _ from "underscore";
import InputMask from 'react-input-mask';
import TextField from "@material-ui/core/TextField";
import { Switch } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

const ToggleEdit = props => {

  const [state, setState] = useState({    
    value: props.value,
    canEdit: props.canEdit,
  });
  if (props.value !== state.value) {
    setState({ ...state, value: props.value });
  }
  // console.log(state);
  // console.log(props);

  const handleValueChange = event => {
    setState({...state, value: event.target.value});
    props.onChange({...state, value: event.target.value});
  };

  const handleToggleChange = event => {
    setState({
      ...state,
      canEdit: event.target.checked,
      value: event.target.checked||props.defaultValue===undefined?state.value:props.defaultValue
    });
    props.onChange({...state, canEdit: event.target.checked, value: event.target.checked||props.defaultValue===undefined?state.value:props.defaultValue});
  };

const SmallSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'inline-flex',
    overflow: 'visible'
  },
  switchBase: {
    padding: 2,
    overflow: "show",
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);
  return (
    <Fragment>
      <div>
        <div style={{display: "inline-block", width: "Calc(100% - 35px)", paddingBottom: state.canEdit?0:1}}>
          {state.canEdit ?
            props.editor ? props.editor({ onChange: handleValueChange, ...(_.omit(props, ['inputProps'])), ...props.inputProps }) :
              <InputMask value={state.value}
                mask={props.mask}
                alwaysShowMask={props.alwaysShowMask ? true : false}
                maskChar={props.maskChar === undefined ? ' ' : props.maskChar}
                formatChars={props.formatChars}
                onChange={handleValueChange}
              >
                {() => <TextField
                  className={props.className}
                  variant={props.variant || 'standard'}
                  label={props.label || ""}
                  required={props.required || false}
                  inputProps={{ ...props.inputProps }}
                  id={props.id}
                  style={{ ...props.style }} />}
              </InputMask>
            : props.render ? props.render({ ...(_.omit(props, ['inputProps'])), ...props.inputProps}) : <div style={{paddingTop:"4px", height:"26px"}}>{state.value}</div>}
        </div>
        <div style={{ display: "inline-block", width: 30, minWidth: 30, maxWidth: 30, paddingTop: "0px", paddingLeft: "5px", textAlign:"center"}}>
          <SmallSwitch
            id="toggle"
            checked={state.canEdit}
            onChange={handleToggleChange}
          />
        </div> 
      </div>
    </Fragment>
  )
};

export default ToggleEdit;